import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {ExDossier} from '../../../class/ex/ex-dossier';
import {HydraService} from '../../../core/services/hydra.service';
import {Fichier} from '../../../class/api/Fichier';
import {DossierAnnexe} from '../../../class/api/DossierAnnexe';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {ToolsService} from '../../services/tools/tools.service';
import {EvaluationSubresourceItem} from '../../../interface/api/Evaluation';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-telecharger-dossier',
    templateUrl: './modal-telecharger-dossier.component.html',
    styleUrls: ['./modal-telecharger-dossier.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatCheckbox, MatDialogActions, MatButton, TranslateModule]
})
export class ModalTelechargerDossierComponent implements OnInit {
    private authService = inject(AuthentificationService);
    private _hydraService = inject(HydraService);
    private toolService = inject(ToolsService);
    dialogRef = inject<MatDialogRef<ModalTelechargerDossierComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);

    public dossier: ExDossier;
    public annexes: DossierAnnexe[];
    public files: Fichier[];
    public publications: Fichier[] = [];

    public selectedFiles: Fichier[] = [];
    public selectedPublications: Fichier[] = [];
    public selectedAnnexes: DossierAnnexe[] = [];

    public downloadFiles: Fichier[] = [];

    private evaluation?: EvaluationSubresourceItem;

    constructor() {
        const data = this.data;

        this.dossier = data.dossier;
        this.evaluation = data.evaluation ?? undefined;
    }

    ngOnInit() {
        this.getAnnexes();
        this.getFiles();
        this.getPublications();
    }

    getAnnexes() {
        this._hydraService.getList('/api/dossiers/' + this.dossier.id + '/annexes').subscribe(res => {
            this.annexes = res['hydra:member'];
        });
    }

    getFiles() {
        let url = '/api/dossiers/' + this.dossier.id + '/documents';
        if (this.evaluation) {
            url += '?evaluation=' + this.evaluation.id;
        }
        this._hydraService.getList(url).subscribe(res => {
            this.files = res['hydra:member'];
        });
    }

    getPublications() {
        let url = '/api/dossiers/' + this.dossier.id + '/publications';
        if (this.evaluation) {
            url += '?evaluation=' + this.evaluation.id;
        }
        this._hydraService.getList(url).subscribe(res => {
            this.publications = res['hydra:member'];
        });
    }

    download() {
        this.toolService.download(
            {
                url: this.genereUrl(),
                originalFilename: this.dossier['numeroDossier'] + '.pdf'
            }
        ).finally(
            () => {
                this.dialogRef.close();
            }
        );
    }

    genereUrl(): string {
        let url;

        if (this.evaluation) {
            url = '/{langue}/evaluations/{evaluationId}/dossiers/{id}/pdf'
                .replace('{evaluationId}', '' + this.evaluation.id);
        } else {
            url = '/{langue}/dossiers/{id}/pdf';
        }

        url = url
            .replace('{langue}', this.authService.userConnected.locale)
            .replace('{id}', '' + this.dossier.id)
            .replace('{fullHtml}', 'true');

        let sepa = '?';

        this.selectedAnnexes.forEach((file: Fichier) => {
            url += sepa + 'files_list[]=' + file['id'];
            sepa = '&';
        });

        this.selectedFiles.forEach((file: Fichier) => {
            url += sepa + 'files_list[]=' + file.id;
            sepa = '&';
        });

        this.selectedPublications.forEach((file: Fichier) => {
            url += sepa + 'files_list[]=' + file.id;
            sepa = '&';
        });

        return url;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    addAll(event: boolean, type: string) {
        let value: Fichier[];

        if (event) {
            switch (type) {
                case 'files':
                    value = [...this.files];
                    break;
                case 'publications':
                    value = [...this.publications];
                    break;
                case 'annexes':
                    value = this.annexes.map(ann => ann.fichier as Fichier);
                    break;
            }
        } else {
            value = [];
        }

        switch (type) {
            case 'files':
                this.selectedFiles = value;
                break;
            case 'publications':
                this.selectedPublications = value;
                break;
            case 'annexes':
                this.selectedAnnexes = value;
                break;
        }
    }

    changeElem(event: boolean, fichier: Fichier, type: string) {
        if (event) {
            switch (type) {
                case 'files':
                    this.selectedFiles.push(fichier);
                    break;
                case 'publications':
                    this.selectedPublications.push(fichier);
                    break;
                case 'annexes':
                    this.selectedAnnexes.push(fichier);
                    break;
            }
        } else {
            switch (type) {
                case 'files':
                    this.selectedFiles = this.selectedFiles.filter(file => file.id !== fichier.id);
                    break;
                case 'publications':
                    this.selectedPublications = this.selectedPublications.filter(file => file.id !== fichier.id);
                    break;
                case 'annexes':
                    this.selectedAnnexes = this.selectedAnnexes.filter(file => file.id !== fichier.id);
                    break;
            }
        }

    }


    isSelect(fichier: Fichier, type: string): boolean {
        switch (type) {
            case 'files':
                return this.selectedFiles.some(item => item.id === fichier.id);
            case 'publications':
                return this.selectedPublications.some(item => item.id === fichier.id);
            case 'annexes':
                return this.selectedAnnexes.some(item => item.id === fichier.id);
            default:
                return false;
        }
    }
}
